<mat-card class="car-card" (click)="goToCarDetailsPage(car.carId)">
  <div class = "image-container">
    @if (carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0) {
      <p class="spinner">
        <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
      </p>
    }
    <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
    <div class = "img-arrow-container">
      <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
      <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
    </div>

    @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
      <div class = "img-counter">
        {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
      </div>
    }
  </div>

  <div class="main-title">
    <div class = "car-make-model">
      {{car.make +" "+ car.model}} <span style="font-weight: normal; margin-left: -5px;"> {{", "+car.year }}  </span>
    </div>

    <div class = "car-price">
      {{ moneyFormat(""+car.getCarPrice(businessLine!).amount) }} {{ car.getCarPrice(businessLine!).currency }}
      @if (businessLine==='RENT') {
        <span>
          /J
          <button matButton class="simple-button" mat-button (click)="showBookingCalendar = !showBookingCalendar;$event.stopPropagation()" cdkOverlayOrigin #trigger1="cdkOverlayOrigin"><mat-icon>calendar_month</mat-icon></button>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger1"
            [cdkConnectedOverlayOpen]="showBookingCalendar">
            <div class="overlay-box">
              <!--
              <h6 *ngFor="let booking of car.bookings ; index as i">
                {{ dateFormat(booking.startDate) }} - {{ dateFormat(booking.endDate) }} - {{booking.status}}
              </h6>
              -->
              <mat-calendar [dateFilter]="filterBookedDates" >
              </mat-calendar>
              <button matButton class="simple-button"  mat-button (click)="showBookingCalendar = !showBookingCalendar; $event.stopPropagation()" ><b> Fermer </b><mat-icon>close</mat-icon></button>
            </div>
          </ng-template>
        </span>
      }
    </div>
  </div>

  <div class="key-details">

    <!-- <div>{{car.year}}</div> -->
    <div>{{car.mileage}} KM</div>
    <div>{{car.gearBox }}</div>
    <div>{{car.fuel}}</div>
    <div>
      <!-- <mat-icon>location_on</mat-icon> -->
      {{ car.city }}
      <span class = "mini-flag">
        <img  mat-card-image src="assets/images/country-flags/{{car.country}}.png" alt="{{car.country}}">
      </span>
    </div>
  </div>


  <!--
  <p>
    Download Progress = {{ progressInfos[i] }} and message Message = {{message[i]}}
  </p>
  -->

  <div class="seller-details">
    <!--
    Postée par
    <a matTooltip="View dealer details"
      (click)="goToSellerPage(car.sellerId);$event.stopPropagation()"
      class="simple-button">

      {{ car.sellerName }}
      <span *ngIf="car.sellerType==='PROFESSIONAL'">
        (Pro)
      </span>

    </a>
    le {{dateFormat(car.created)}}
    -->
    <div>Vendu par
      <button mat-button matTooltipPosition="above" matTooltip="View dealer details"
        (click)="goToSellerPage(car.providerId);$event.stopPropagation()"
        class="simple-button">
        <mat-icon>{{(car.providerType==='PROFESSIONAL')?'corporate_fare':'person'}} </mat-icon>

        @if (car.providerType==='PROFESSIONAL') {
          <span>
            {{ car.providerBusinessName }}
          </span>
        }
        @if (car.providerType!=='PROFESSIONAL') {
          <span>
            {{ car.providerName }}
          </span>
        }

      </button>

    </div>
    <div>Postée le {{dateFormat(car.created)}}</div>
  </div>

  <!--
  <div class="car-price-offer">
    <div *ngIf = "isSeller">
      <button class="button" mat-button (click)="openPriceDialog(car.carId);$event.stopPropagation()">Nouveau Prix</button>
    </div>

    <div *ngIf="!isSeller">
      <button class="button" mat-button (click)="openOfferDialog(car.carId) ;$event.stopPropagation()">Faire une offre</button>
    </div>

    <div *ngIf="!isSeller">
      Mon offre actuelle : {{(car.offerHistory != null) ? moneyFormat(""+car.offerHistory[car.offerHistory.length - 1]?.amount): 0}} FCFA
    </div>
  </div>
  -->

  <div class="car-details">

    <p>
      Seller: <button mat-button matTooltipPosition="above" matTooltip="View dealer details" (click)="goToSellerPage(car.providerId);$event.stopPropagation()"> {{ car.providerId }} </button>
      and car Id : {{car.carId}}

    </p>

    <p>
      <span>
        Mileage: {{car.mileage}} KM,
      </span>
      <span>
        Description: {{car.description}} _ total images =  {{car.imagesFilenames?.length}}
      </span>
    </p>
    <p>
      Created: {{dateFormat(car.created)}},  Last Updated: {{dateFormat(car.lastUpdated)}}
    </p>
  </div>

</mat-card>
